




import { Component, Prop, Vue } from "vue-property-decorator";
import { InvoiceCategoryCode } from "@/models/invoices";
import { InvoiceCategoryCodesMap } from "@/data/enums/invoice";

@Component({
  components: {
    "date-range-stat": () =>
      import("@/components/app/global/stats/_dateRangeStat.vue")
  }
})
export default class CashTotal extends Vue {
  // Props
  @Prop({ default: "total" })
  public readonly invoiceCategory!: InvoiceCategoryCode | "total";

  //Data
  public invoiceCategoryCodesMap = InvoiceCategoryCodesMap();

  // Getters
  public get params() {
    const params = {};
    if (this.invoiceCategory) params["report"] = `["${this.invoiceCategory}"]`;
    return params;
  }

  public get label() {
    if (this.invoiceCategory === "total") return this.$t("_.total_cash");
    return this.$t("_.total_cash_object", {
      object: this.$_.lowerCase(
        this.invoiceCategoryCodesMap[this.invoiceCategory].label as string
      )
    });
  }

  public get attrs() {
    return this.$_.merge(
      {
        id: "cashTotalStats",
        label: this.label,
        scope: "transactions_invoice" + `_${this.invoiceCategory}`,
        params: {
          type: "transactions_invoice",
          date_to: this.$moment().format("YYYY-MM-DD"),
          ...this.params
        },
        "value-path": `${this.invoiceCategory ||
          "total"}.result.{currencyCode}[0].amount_formatted`,
        "tooltip-message": this.$t("_sentence.total_cash_desc")
      },
      this.$attrs
    );
  }
}
